// Consent Management Platform (CMP) integration

import store from '@/plugins/store'
import {MUTATION_UPDATE_COOKIE_CONSENT_STATE} from '@/plugins/store'

window.addEventListener("ucEvent", function (e) {
  // DEV: console.log('ucEvent event', e)
  if (e.detail && e.detail.event == "consent_status") {
    store.commit(MUTATION_UPDATE_COOKIE_CONSENT_STATE, e.detail)
  }
});

let appCmp = {}

export default appCmp
